import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModuleService } from '../services/module.service';

@Injectable({
    providedIn: 'root',
})
export class ModuleAvailableGuard implements CanActivate {
    constructor(private moduleService: ModuleService, private router: Router) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        // getting the identifier from routes
        const moduleIdentifier = next.data ? next.data.identifier : undefined;
        return this.moduleService.getModules().pipe(
            map((modules) => {
                // it means that is a public module
                if (!moduleIdentifier) {
                    return true;
                }

                const moduleExists = modules.some((module) => module.identifier === moduleIdentifier);

                if (!moduleExists) {
                    this.router.navigate(['/']); // Redirect to home or error page
                    return false;
                }

                return true;
            })
        );
    }
}
